import React, { useEffect, useState } from 'react'
import style from './style.module.scss'

import {
  FieldProps,
  GroupProps,
} from '../../utils/functionsInterfaces'

import { handleAddField } from '../../functions/addFieldStandard'
import { handleAddAttachmentsFieldOutsideGroup } from '../../functions/addFieldAttachmentsNotGroup'
import { handleAddFieldAttachments } from '../../functions/addFieldAttachments'
import { handleAddFieldOutsideGroup } from '../../functions/addFieldStandardNotGroup'
import { handleAddGroup } from '../../functions/addGroup'
import { handleAddPersonalDetailField } from '../../functions/addFieldPersonalDetails'
import { handleAddPersonalDetailFieldOutsideGroup } from '../../functions/addFieldPersonalDetailsNotGroup'
import { handleCopyGroup } from '../../functions/copyGroup'
import { handleRemoveField } from '../../functions/removeField'
import { handleRemoveFieldInGroup } from '../../functions/removeFieldInGroup'
import { handleRemoveGroup } from '../../functions/removeGroup'
import { formatNameAlias } from '../../functions/formatNameAlias'
import { getFormSideProps } from '../../functions/getFormSideProps'
import { getSkillId } from '../../functions/getSkill'
import { getTabId } from '../../functions/getTab'
import { publishForm } from '../../functions/publishForm'
import { saveForm } from '../../functions/updateForm'
import { toggleGroupVisibility } from '../../functions/toggleGroupVisibility'
import { generatePayload } from '../../functions/generatePayload'
import { generateJSON } from '../../functions/generateJSON'

import {
  handleInputAliasChange,
  handleInputIdChange,
  handleInputItemIdChange,
  handleInputNameChange,
  handleInputSkillChange,
  handleInputTabChange,
} from '../../utils/functionsInputs'

import { SelectFieldPersonalDetails } from '../../components/ui/selects'
import { useAuthContext } from '../../hooks/auth'
import { Helmet } from 'react-helmet-async';
import { DragDropContext, Draggable, Droppable, DropResult } from '@hello-pangea/dnd'
import { useLocation } from 'react-router-dom'
import { ButtonAddAttachmentsFieldOutsideGroup, ButtonAddField, ButtonAddFieldAttachments, ButtonAddFieldOutsideGroup, ButtonAddGroup, ButtonCopyGroup, ButtonGenerateJson, ButtonGeneratePayload, ButtonPublishForm, ButtonRemoveGroup, ButtonSaveForm } from '../../components/ui/buttons'
import { InputsInfosFields, InputsInfosGroups, InputsInfosPages, InputSkill, InputTab } from '../../components/ui/inputs'
import FormGroups from '../../components/FormGroups'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faAngleUp, faFileArrowUp, faFilePowerpoint, faLayerGroup } from '@fortawesome/free-solid-svg-icons'
import { Field } from '../../components/fields'
import { fieldsPersonalDetails } from '../../functions/personalDetails'
import { displaySuccess } from '../../utils/messageToast'

export default function Form({ create = true }) {

  const { authorization, authorizationForce, authorizationRA, user, signOut } = useAuthContext();
  const clientIdForce = localStorage.getItem("clientIdForce") as string;
  const clientId = user?.clientId as string
    ? localStorage.getItem("inForce") === "true"
      ? clientIdForce
      : user?.clientId as string
    : clientIdForce
  const ambient = user?.ambient as string;

  const personalDetails = fieldsPersonalDetails();

  const [form, setForm] = useState<any[]>([...personalDetails]);

  const [nameForm, setNameForm] = useState('');
  const [pageId, setPageId] = useState(create ? 'data' : '');
  const [namePage, setNamePage] = useState(create ? 'Data' : '');
  const [skillIdForm, setSkillIdForm] = useState('');
  const [tabIdForm, setTabIdForm] = useState('');
  const [formId, setFormId] = useState('');

  const structureForm = {
    id: pageId,
    name: namePage,
    type: "page",
    template: {
      children: [...form],
    }
  };

  const [isInForce, setIsInForce] = useState(localStorage.getItem("inForce") === "true" ? true : false);
  const token = isInForce ? authorizationForce : authorizationRA;
  const [groups, setGroups] = useState<GroupProps[]>([])
  const [fields, setFields] = useState<FieldProps[]>([])
  const [search, setSearch] = useState('')
  const [showTopContainer, setShowTopContainer] = useState(false)
  const [expandedGroups, setExpandedGroups] = useState<string[]>([])
  const [showTopPageContainer, setShowTopPageContainer] = useState(true)
  const [skillName, setSkillName] = useState('')
  const [tabName, setTabName] = useState('')
  const [itemId, setItemId] = useState('')
  const [aliasFormResult, setAliasFormResult] = useState('')
  const [checkTheFunction, setCheckTheFunction] = useState(true)
  const [idFormSaved, setIdFormSaved] = useState('')
  const [buttonSave, setButtonSave] = useState(false)
  const [buttonPublish, setButtonPublish] = useState(false)
  const [addFieldPersonalDetails, setAddFieldPersonalDetails] = useState('')
  const [loadingButtonSave, setLoadingButtonSave] = useState(false);
  const [loadingButtonPublish, setLoadingButtonPublish] = useState(false);
  const [loadingButtonGeneratePayload, setLoadingButtonGeneratePayload] = useState(false);
  const [loadingButtonGenerateJson, setLoadingButtonGenerateJson] = useState(false);
  const [searchFormId, setSearchFormId] = useState('');
  const [isData, setIsData] = useState(false)
  const [isCreated, setIsCreated] = useState(create ? true : false)
  const [expandedPage, setExpandedPage] = useState(true)

  const location = useLocation();

  const useIsomorphicEffect = useEffect;
  const [cacheCleared, setCacheCleared] = useState(false);

  useIsomorphicEffect(() => {
    const executeClearCache = async () => {
      await clearCacheClient();
    };
    executeClearCache();

  }, []);

  const clearCacheClient = async () => {
    try {
      const cacheKeys = await caches.keys();

      if (cacheKeys.length > 0) {
        await Promise.all(cacheKeys.map(key => caches.delete(key)));
        setCacheCleared(true);
      }
    } catch (error: any) {
      return error
    }
  };

  // Polling para detectar mudanças no localStorage ("inForce") na mesma aba
  useEffect(() => {
    const interval = setInterval(() => {
      const storedInForce = localStorage.getItem("inForce") === "true";
      if (storedInForce !== isInForce) {
        setIsInForce(storedInForce);
      }
    }, 1000); // verifica a cada 1 segundo
    return () => clearInterval(interval);
  }, [isInForce]);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const fromListForms = queryParams.get('formId');
    setSearchFormId(fromListForms || '');

    if (searchFormId) {
      getFormSideProps(
        setExpandedPage,
        setShowTopPageContainer,
        setNamePage,
        setPageId,
        setIsData,
        searchFormId,
        setFormId,
        setNameForm,
        setSkillIdForm,
        setTabIdForm,
        setItemId,
        setGroups,
        setFields,
        setShowTopContainer,
        setButtonPublish,
        clientId,
        setAliasFormResult,
        setForm,
        ambient,
        setSkillName,
        authorization,
        setTabName,
        signOut
      );
    }
  }, [location, searchFormId, ambient, clientId, authorization, authorizationRA, signOut]);

  const generateJson = async () => {
    setLoadingButtonGenerateJson(true)
    const json = generateJSON(
      undefined,
      isCreated,
      pageId,
      formId,
      nameForm,
      skillIdForm,
      tabIdForm,
      aliasFormResult,
      form
    )
    navigator.clipboard.writeText(
      JSON.stringify(json, null, 2)
    );
    displaySuccess("Template do formulário copiado para a área de transferência!")
    setLoadingButtonGenerateJson(false)
  }

  const onDragEnd = (result: DropResult) => {
    const { source, destination } = result;

    // Caso o item seja solto fora de um destino válido
    if (!destination) return;

    const updatedForm = [...form]; // Faz uma cópia do estado atual

    // Localiza o índice do grupo principal (droppable-page)
    const isSourceMainGroup = source.droppableId === 'droppable-page';
    const isDestMainGroup = destination.droppableId === 'droppable-page';

    // Se o item vem do grupo principal (droppable-page), encontramos o grupo de origem
    const sourceGroupIndex = isSourceMainGroup
      ? -1 // Se for o grupo principal, não há grupo específico (os itens ficam fora de grupos)
      : updatedForm.findIndex(group => group.uuid === source.droppableId);

    // Se o item vai para o grupo principal (droppable-page), ele fica fora de qualquer grupo
    const destGroupIndex = isDestMainGroup
      ? -1 // Se for o grupo principal, não há grupo específico
      : updatedForm.findIndex(group => group.uuid === destination.droppableId);

    let movedItem: any;

    // 1. Remover o item da origem
    if (isSourceMainGroup) {
      // Se for o grupo principal, removemos o item diretamente do form
      movedItem = updatedForm.splice(source.index, 1)[0];
    } else {
      // Caso contrário, removemos o item do grupo de origem
      const sourceGroup = updatedForm[sourceGroupIndex];
      if (Array.isArray(sourceGroup.children)) {
        movedItem = sourceGroup.children.splice(source.index, 1)[0];
      }
    }

    // 2. Adicionar o item no destino
    if (isDestMainGroup) {
      // Se o item vai para o grupo principal, simplesmente adiciona no array
      updatedForm.splice(destination.index, 0, movedItem);
    } else {
      // Se o item vai para um grupo específico, adiciona-o nesse grupo
      const destGroup = updatedForm[destGroupIndex];
      if (!Array.isArray(destGroup.children)) {
        destGroup.children = []; // Inicializa o grupo se necessário
      }
      destGroup.children.splice(destination.index, 0, movedItem);
    }

    // Atualiza o estado
    setForm(updatedForm);
    setButtonSave(true);
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <div>

        <Helmet>
          <title>Tech Forms - Formulário</title>
        </Helmet>

        <div className={style.container}>

          <div className={style.tabSkill}>
            <div className={style.inputsHeader}>

              {!create && <div className={style.containerRowObject}>
                {/* <h5 className={style.h5hidden}>Id</h5> */}
                <div className={style.rowObjects}>
                  <p className={style.titles}>Id</p>
                  <InputsInfosPages
                    placeholder='Insira o Id do formulário'
                    type='text'
                    value={formId}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                      handleInputIdChange(event, setFormId)
                    }
                    disabled={true}
                    style={{ cursor: 'not-allowed' }}
                  />
                </div>
              </div>}

              {!create && <div className={style.containerRowObject}>
                {/* <h5 className={style.h5hidden}>ItemId</h5> */}
                <div className={style.rowObjects}>
                  <p className={style.titles}>ItemId</p>
                  <InputsInfosPages
                    placeholder='Insira o ItemId'
                    type='text'
                    value={itemId}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                      handleInputItemIdChange(event, setItemId)
                    }
                    disabled={true}
                    style={{ cursor: 'not-allowed' }}
                  />
                </div>
              </div>}

              <div className={style.containerRowObject}>
                {/* <h5 className={style.h5hidden}>Nome</h5> */}
                <div className={style.rowObjects}>
                  <p className={style.titles}>Nome</p>
                  <InputsInfosPages
                    placeholder='Insira o nome do formulário'
                    type='text'
                    value={nameForm}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                      handleInputNameChange(event, setNameForm)
                    }
                    onBlur={() => {
                      formatNameAlias(nameForm, setAliasFormResult)
                      setNamePage(nameForm)
                      setButtonSave(true)
                    }}
                  />
                </div>
              </div>

              <div className={style.containerRowObject}>
                {/* <h5 className={`${style.h5hidden} ${!skillName ? style.h5hiddenClear : ''
                    }`}>{skillName}</h5> */}
                <div className={style.rowObjects}>
                  <p className={style.titles}>SkillId</p>
                  <InputSkill
                    placeholder='Insira a skillId'
                    type='text'
                    skillName={skillName}
                    value={skillIdForm}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                      handleInputSkillChange(event, setSkillIdForm)
                    }
                    onBlur={() => {
                      getSkillId(skillIdForm, authorization, ambient, setSkillName, signOut)
                      setButtonSave(true)
                    }}
                  />
                </div>
              </div>

              <div className={style.containerRowObject}>
                {/* <h5 className={style.h5hidden}>Alias</h5> */}
                <div className={style.rowObjects}>
                  <p className={style.titles}>Alias</p>
                  <InputsInfosPages
                    placeholder='Insira o alias'
                    type='text'
                    value={aliasFormResult}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                      handleInputAliasChange(event, setAliasFormResult)
                    }
                    onBlur={() => {
                      setButtonSave(true)
                    }}
                  />
                </div>
              </div>

              <div className={style.containerRowObject}>
                {/* <h5 className={`${style.h5hidden} ${!tabName ? style.h5hiddenClear : ''
                    }`}>{tabName}</h5> */}
                <div className={style.rowObjects}>
                  <p className={style.titles}>TabId</p>
                  <InputTab
                    placeholder='Insira a tabId'
                    type='text'
                    tabName={tabName}
                    value={tabIdForm}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                      handleInputTabChange(event, setTabIdForm)
                    }
                    onBlur={() => {
                      getTabId(tabIdForm, authorization, ambient, setTabName, signOut)
                      setButtonSave(true)
                    }}
                  />
                </div>
              </div>

            </div>

            <div className={style.topContainer}>

              <ButtonAddGroup onClick={() => handleAddGroup(setForm, setButtonSave)} />

              <ButtonAddFieldOutsideGroup onClick={() => handleAddFieldOutsideGroup(setForm, setButtonSave)} />

              <ButtonAddAttachmentsFieldOutsideGroup onClick={() => handleAddAttachmentsFieldOutsideGroup(setForm, setButtonSave)} />

              <SelectFieldPersonalDetails
                value={addFieldPersonalDetails}
                onChange={(event: React.ChangeEvent<HTMLSelectElement>) => {
                  const newValue = event.target.value
                  setAddFieldPersonalDetails(newValue)
                  handleAddPersonalDetailFieldOutsideGroup(
                    form,
                    setForm,
                    newValue,
                    setAddFieldPersonalDetails,
                    setButtonSave
                  )
                }}
              />

              <ButtonSaveForm
                loading={loadingButtonSave}
                buttonSave={buttonSave}
                onClick={() =>
                  saveForm(
                    setLoadingButtonSave,
                    generateJSON(
                      structureForm,
                      isCreated,
                      pageId,
                      formId,
                      nameForm,
                      skillIdForm,
                      tabIdForm,
                      aliasFormResult,
                      form
                    ),
                    authorization,
                    token,
                    setButtonPublish,
                    setButtonSave,
                    setIdFormSaved,
                    nameForm,
                    skillIdForm,
                    tabIdForm,
                    aliasFormResult,
                    ambient,
                    setTabName,
                    setSkillName,
                    signOut
                  )
                } />

              <ButtonPublishForm
                loading={loadingButtonPublish}
                buttonPublish={buttonPublish}
                onClick={() => publishForm(
                  setExpandedPage,
                  setShowTopPageContainer,
                  setNamePage,
                  setPageId,
                  setIsData,
                  setLoadingButtonPublish,
                  idFormSaved,
                  setSearch,
                  setFormId,
                  setNameForm,
                  setSkillIdForm,
                  setTabIdForm,
                  setItemId,
                  setGroups,
                  setFields,
                  setShowTopContainer,
                  setButtonSave,
                  setButtonPublish,
                  clientId,
                  token,
                  aliasFormResult,
                  setAliasFormResult,
                  setForm,
                  checkTheFunction,
                  ambient,
                  setTabName,
                  setSkillName,
                  authorization,
                  signOut
                )
                }
              />

              {!create &&
                <>
                  <ButtonGeneratePayload
                    loading={loadingButtonGeneratePayload}
                    onClick={() =>
                      generatePayload(
                        setLoadingButtonGeneratePayload,
                        clientId,
                        authorization,
                        ambient,
                        formId,
                        signOut
                      )}
                  />

                  <ButtonGenerateJson
                    loading={loadingButtonGenerateJson}
                    onClick={generateJson}
                  />
                </>
              }

            </div>
          </div>

          <div className={style.groupContainer}>

            <div className={style.headerGroup}>

              <div className={style.iconIdentifier}>
                <FontAwesomeIcon
                  icon={faLayerGroup}
                  style={{ color: '#FFD43B' }}
                />
              </div>

              <InputsInfosFields
                placeholder='Digite o ID da pagina'
                value={pageId}
                onChange={(e) => {
                  setPageId(e.target.value)
                }}
                onBlur={() => {
                  setButtonSave(true)
                }}
              />

              <InputsInfosFields
                placeholder='Digite o nome da pagina'
                value={namePage}
                onChange={(e) => {
                  setNamePage(e.target.value)
                }}
                onBlur={() => {
                  setButtonSave(true)
                }}
              />

              <button
                type='button'
                onClick={() => {
                  setExpandedPage(!expandedPage)
                }}
                className={`${style.buttonToggleGroupVisibility} ${style.buttonIcon}`}
                title='Esconder Campos'
              >
                {expandedPage ? (
                  <FontAwesomeIcon
                    icon={faAngleUp}
                    className={style.faIcon}
                  />
                ) : (
                  <FontAwesomeIcon
                    icon={faAngleDown}
                    className={style.faIcon}
                  />
                )}
              </button>

            </div>

            {expandedPage &&
              <Droppable droppableId={`droppable-page`} type='page'>
                {(provided) => (
                  <div ref={provided.innerRef} {...provided.droppableProps}>
                    {form.map((item: any, index: number) => (
                      <Draggable
                        key={item.uuid}
                        draggableId={item.uuid}
                        index={index}
                      >
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            {item.type === 'group' ? (
                              <div key={index} className={style.groupContainer} >

                                <div className={style.headerGroup}>

                                  <div className={style.iconIdentifier}>
                                    <FontAwesomeIcon
                                      icon={faLayerGroup}
                                      style={{ color: '#FFD43B' }
                                      }
                                    />
                                  </div>

                                  <div className={style.inputsGroup}>
                                    < InputsInfosGroups
                                      placeholder='Digite o ID do grupo'
                                      value={item.id}
                                      onChange={(e) => {
                                        const newId = e.target.value
                                        const updatedForm = form.map((group, idx) => {
                                          if (index === idx) {
                                            return { ...group, id: newId }
                                          }
                                          return group
                                        })
                                        setForm(updatedForm)
                                      }}
                                      onBlur={() => {
                                        setButtonSave(true)
                                      }}
                                    />

                                    < InputsInfosGroups
                                      placeholder='Digite o nome do grupo'
                                      value={item.name}
                                      onChange={(e) => {
                                        const newName = e.target.value
                                        const updatedForm = form.map((group, idx) => {
                                          if (index === idx) {
                                            return { ...group, name: newName }
                                          }
                                          return group
                                        })
                                        setForm(updatedForm)
                                      }}
                                      onBlur={() => {
                                        setButtonSave(true)
                                      }}
                                    />
                                  </div>

                                  <div className={style.buttonsGroup}>
                                    < ButtonAddField
                                      onClick={() => {
                                        handleAddField(
                                          item.uuid,
                                          expandedGroups,
                                          form,
                                          setForm,
                                          setButtonSave
                                        )
                                        setExpandedGroups([...expandedGroups, item.uuid])
                                      }}
                                    />

                                    < ButtonAddFieldAttachments
                                      onClick={() => {
                                        handleAddFieldAttachments(
                                          item.uuid,
                                          expandedGroups,
                                          form,
                                          setForm,
                                          setButtonSave
                                        )
                                        setExpandedGroups([...expandedGroups, item.uuid])
                                      }}
                                    />

                                    < ButtonCopyGroup
                                      onClick={() =>
                                        handleCopyGroup(
                                          item.id,
                                          item.name,
                                          form,
                                          setForm,
                                          item.uuid || '',
                                          setButtonSave
                                        )
                                      }
                                    />

                                    < ButtonRemoveGroup
                                      onClick={() =>
                                        handleRemoveGroup(
                                          item.id,
                                          form,
                                          setForm,
                                          item.uuid,
                                          setButtonSave
                                        )
                                      }
                                    />

                                    < SelectFieldPersonalDetails
                                      value={addFieldPersonalDetails}
                                      onChange={(
                                        event: React.ChangeEvent<HTMLSelectElement>
                                      ) => {
                                        const newValue = event.target.value
                                        setAddFieldPersonalDetails(newValue)
                                        handleAddPersonalDetailField(
                                          item.id,
                                          expandedGroups,
                                          form,
                                          setForm,
                                          newValue,
                                          setAddFieldPersonalDetails,
                                          setButtonSave
                                        )
                                        setExpandedGroups([...expandedGroups, item.uuid])
                                      }}
                                      title='Adicionar Campos Customizados'
                                    />

                                    <button
                                      type='button'
                                      onClick={() =>
                                        toggleGroupVisibility(
                                          item.uuid || '',
                                          expandedGroups,
                                          setExpandedGroups
                                        )
                                      }
                                      className={`${style.buttonToggleGroupVisibility} ${style.buttonIcon}`}
                                      title='Esconder Campos'
                                    >
                                      {
                                        expandedGroups.includes(item.uuid) ? (
                                          <FontAwesomeIcon
                                            icon={faAngleUp}
                                            className={style.faIcon}
                                          />
                                        ) : (
                                          <FontAwesomeIcon
                                            icon={faAngleDown}
                                            className={style.faIcon}
                                          />
                                        )}
                                    </button>
                                  </div>

                                </div>

                                {expandedGroups.includes(item.uuid) && (
                                  <FormGroups
                                    form={form}
                                    setForm={setForm}
                                    groups={groups}
                                    expandedGroups={expandedGroups}
                                    setExpandedGroups={setExpandedGroups}
                                    handleCopyGroup={handleCopyGroup}
                                    handleRemoveGroup={handleRemoveGroup}
                                    handleAddField={handleAddField}
                                    handleAddFieldAttachments={handleAddFieldAttachments}
                                    handleAddPersonalDetailField={handleAddPersonalDetailField}
                                    handleRemoveField={handleRemoveField}
                                    handleRemoveFieldInGroup={handleRemoveFieldInGroup}
                                    toggleGroupVisibility={toggleGroupVisibility}
                                    setAddFieldPersonalDetails={setAddFieldPersonalDetails}
                                    addFieldPersonalDetails={addFieldPersonalDetails}
                                    setButtonSave={setButtonSave}
                                    authorization={authorization}
                                    clientId={clientId}
                                    ambient={ambient}
                                    formId={formId}
                                    item={item}
                                    outsideTheGroup={false}
                                    index={index}
                                    isPersonalDetails={false}
                                    structureForm={structureForm}
                                  />
                                )}

                              </div>
                            ) : item.fieldType === 'multiple_files' ? (
                              /* campo de anexo fora do grupo */
                              <div key={item.uuid} className={item.fieldType === 'personal_details' ? style.fieldContainerPersonalDetails : style.fieldContainer
                              }>
                                <div className={style.iconIdentifier}>
                                  <FontAwesomeIcon
                                    icon={faFileArrowUp}
                                    style={{ color: '#0000fa' }}
                                  />
                                </div>

                                <Field
                                  fieldGroupInGroup={item}
                                  indexFieldGroupInGroup={index}
                                  index={index}
                                  field={item}
                                  handleRemoveFieldInGroup={handleRemoveFieldInGroup}
                                  handleRemoveField={handleRemoveField}
                                  form={form}
                                  setForm={setForm}
                                  outsideTheGroup={true}
                                  isPersonalDetail={false}
                                  setButtonSave={setButtonSave}
                                  authorization={authorization}
                                  clientId={clientId}
                                  ambient={ambient}
                                  formId={formId}
                                  groupId={pageId}
                                />

                              </div>
                            ) : item.fieldType === 'personal_details' ? (
                              /* campo personal details fora do grupo */
                              <div key={index} className={item.fieldType === 'personal_details' ? style.fieldContainerPersonalDetails : style.fieldContainer
                              }>
                                <div className={style.iconIdentifier}>
                                  <FontAwesomeIcon
                                    icon={faFilePowerpoint}
                                    style={{ color: '#63E6BE' }}
                                  />
                                </div>

                                <Field
                                  fieldGroupInGroup={item}
                                  indexFieldGroupInGroup={index}
                                  index={index}
                                  field={item}
                                  handleRemoveFieldInGroup={handleRemoveFieldInGroup}
                                  handleRemoveField={handleRemoveField}
                                  form={form}
                                  setForm={setForm}
                                  outsideTheGroup={true}
                                  isPersonalDetail={true}
                                  setButtonSave={setButtonSave}
                                  authorization={authorization}
                                  clientId={clientId}
                                  ambient={ambient}
                                  formId={formId}
                                  groupId={undefined}
                                />

                              </div>
                            ) : (
                              /* campo padrao fora do grupo */
                              <div key={index} className={item.fieldType === 'personal_details' ? style.fieldContainerPersonalDetails : style.fieldContainer
                              }>

                                <Field
                                  fieldGroupInGroup={item}
                                  indexFieldGroupInGroup={index}
                                  index={index}
                                  field={item}
                                  handleRemoveFieldInGroup={handleRemoveFieldInGroup}
                                  handleRemoveField={handleRemoveField}
                                  form={form}
                                  setForm={setForm}
                                  outsideTheGroup={true}
                                  isPersonalDetail={false}
                                  setButtonSave={setButtonSave}
                                  authorization={authorization}
                                  clientId={clientId}
                                  ambient={ambient}
                                  formId={formId}
                                  groupId={pageId}
                                />

                              </div>
                            )}

                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            }

          </div>

        </div>
      </div>
    </DragDropContext>
  )
}